export default {
    drug: null,
    drugsSummary: null,
    summaryTemp: null,
    productsSummary: null,
    category: null,
    dose: null,
    drugTab: 1,
    product: null,
    veterinaryProductsMap: null,
    humanProductsMap: null,
    dose_index: null,
    reference: null,
    showProducts: false,
    virtualScroll: 0,
    searchValue: "",
    classes: [],
    itemsList: [],
    hasFilter: false,
    dogFilter: false,
    catFilter: false,
    presentationList: [],
    presentationFilter: undefined,
    classesList: [],
    classesFilter: undefined,
    brandList: [],
    brandFilter: [],
    activePrinciplesList: [],
    activePrinciplesFilter: [],
    systemFilter: undefined,
    systemClasses: null,
    
    petSizes: [],
    petSizesFilter: [],

    petAges: [],
    petAgesFilter: [],

    petBreeds: [],
    petBreedsFilter: [],
    
    features: [],
    featuresFilter: [],

    brandLines: {},
    lines: [],
    brandLinesFilter: undefined 
}